"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const assets_1 = require("~/assets");
const ErrorModal_1 = __importDefault(require("./ErrorModal"));
function ForbiddenModal() {
    const { t } = (0, react_i18next_1.useTranslation)('errors');
    return (react_1.default.createElement(ErrorModal_1.default, { icon: assets_1.svgForbidden, header: t('forbidden.error-header'), messages: [t('forbidden.cannot-complete'), t('forbidden.no-permissions')], imgClassName: "forbidden" }));
}
exports.default = ForbiddenModal;
